import React from 'react';
import { PrivacyInformation } from '../component/common/LegalDocuments';
import LegalPage from './LegalPage';

function OsobniUdaje() {
    return <LegalPage title="Informace o zpracování osobních údajů">
        <PrivacyInformation />
    </LegalPage>;
}

export default OsobniUdaje;
